import { render, staticRenderFns } from "./mediaObject.vue?vue&type=template&id=996eb892&scoped=true&"
import script from "./mediaObject.vue?vue&type=script&lang=js&"
export * from "./mediaObject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "996eb892",
  null
  
)

export default component.exports